import * as React from 'react'
import { Card, WithStyles, CardMedia, CardContent, Typography, Theme, createStyles, withStyles, Chip } from '@material-ui/core'
import ReactHtmlParser from 'react-html-parser'
import { compose } from 'redux'
import Link from 'src/shared/Link/Link'
import { RootState } from 'src/core/redux/reducer'
import {connect} from 'react-redux'
import { IProduct } from 'src/type/product'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { RouteComponentProps, withRouter } from 'react-router'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import autobind from 'autobind-decorator'
import { config } from 'src/conf/config'

const styles = (t: Theme) => createStyles({
    card: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: '420px',
        cursor: 'pointer',
        [t.breakpoints.up('md')]: {
            height: '420px'
        }
      },
      media: {
        height: '100px',
        paddingTop: '50.25%',
      },
      cardContent: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: t.spacing.unit * 2,
        paddingRight: t.spacing.unit * 2
      },
      content: {
          position: 'relative',
          marginTop: t.spacing.unit * 2,
          maxHeight: '150px',
          overflow: 'hidden',
          fontSize: '0.85rem',
          '&:after': {
              background: 'linear-gradient(top, rgba(255,255,255,0), #fff 100%)',
              content: '""',
              position: 'absolute',
              height: '80px',
              bottom: 0,
              right: 0,
              left: 0,
          }
      },
      title: {
          lineHeight: 'inherit',
          marginBottom: t.spacing.unit * 2
      },
      chip: {
          marginRight: t.spacing.unit / 4,
          marginBottom: t.spacing.unit / 2,
          fontSize: '0.75rem',
          height: '26px',
          [t.breakpoints.up('md')]: {
              fontSize: '10px'
          }
      },
});


interface IProps extends WithI18n, 
WithStyles<typeof styles>,
WithGlobalProgress,
WithToast,
RouteComponentProps<any>,
ReturnType<typeof state2props>,
ReturnType<typeof dispatch2props> {
    entity: IProduct;
}

/*
   Avoid validateDOMNesting(...)
*/
const Description = (description: string) => (ReactHtmlParser(description))

class ProductCard extends React.Component<IProps, {}> {
    render() {
        const {classes, entity, mapProductType} = this.props
        return (
            <Link to={`product-detail/${entity.product_type}`}>
                <Card key={`product-card-${entity.id}`} className={classes.card}>
                    <CardMedia
                        className={classes.media}
                        image={entity.image_cover_url ? entity.image_cover_url : config.IMG_BASE_PATH + "/product-default.png"}
                        title={entity.name}
                        key={`product-card-media-${entity.id}`} 
                    />
        
                    <CardContent key={`product-card-content-${entity.id}`} className={classes.cardContent}>
                        <Typography variant="h6" gutterBottom className={classes.title} key={`product-card-title-${entity.id}`} >
                            {entity.name}
                        </Typography>

                        {entity.product_type &&
                            <Typography variant="caption" gutterBottom className={classes.title} key={`product-card-type-${entity.id}`} >
                                {mapProductType.get(entity.product_type)}
                            </Typography>
                        }
                        {this.categoriesRendering(entity)}
                        <br/>
                        <div key={`product-card-description-short-${entity.id}`}  className={classes.content}>{Description(entity.description_short)}</div>
                        <br/>
                    </CardContent>
                </Card>
           </Link>
        )
    } 

    @autobind
    private categoriesRendering(p: IProduct){
        const {mapName, classes} = this.props;
        return (
            <div>
                {p.category_produit &&
                    p.category_produit.split(",").map(c => 
                        mapName.get(c) !== undefined ? <Chip key={`category-produit-${c}`}  label={mapName.get(c)} className={classes.chip} /> : ''
                    )
                }
            </div>
        )
    }
}

const state2props = (state: RootState) => ({
    mapName: state.utils.mapCategories,
    mapProductType: state.utils.mapProductType
})

const dispatch2props = (dispatch: any) => ({
});

export default compose(
    withI18n,
    withRouter,
    withStyles(styles),
    withGlobalProgress,
    withToast,
    connect(state2props, dispatch2props),
)(ProductCard)


// WEBPACK FOOTER //
// ./src/shared/Product/ProductCard.tsx